import "../Guide.css";
import Stage from "../../stage/Stage";
import apoc from "../../assets/apoc.png";

function Apoc() {
  return (
    <Stage>
      <h1>Apocalypse Leather Armor</h1>
      <p className="guideText">
        Apocalypse Leather is SEN/AGI and not-Omni only.
      </p>
      <img
        src={apoc}
        alt="Apocalypse Leather suit stats"
        className="guidePic"
        style={{ maxHeight: "100rem" }}
      />
      <p className="guideContext">
        QL 200 Apocalypse Leather modifiers from AO Setups
      </p>
    </Stage>
  );
}

export default Apoc;
